import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { getCategoryDataForType } from '@selectors/data-types-selector';

const StyledFormControlLabel = withStyles({
  root: {
    marginLeft: 0,
    marginRight: 0
  }
})(FormControlLabel);

const Toggle = ({
  /* eslint-disable no-unused-vars */
  data,
  dataCheckError,
  dataCheckErrorStyle,
  dataCheckValue,
  dataExtract,
  dataField,
  dataName,
  labelPosition,  // not used in new API (default is label on right)
  /* eslint-enable no-unused-vars */
  style,
  styleName,
  disabled,
  error,
  errorStyle,
  showError,
  label,
  labelStyle,
  toggled,
  onClick,
  name,
  ...other
}) => (
  <div style={style || {}} styleName={styleName || ''}>
    <StyledFormControlLabel
      control={
        <Switch
          checked={toggled || false}
          onClick={onClick}
          disabled={disabled || showError}
          name={name}
          color="primary"
          {...other}
        />
      }
      label={<span style={labelStyle}>{label}</span>}
      disabled={disabled || showError}
    />
    {showError && <div style={errorStyle || {}}>{error}</div>}
  </div>
);

Toggle.propTypes = {
  data: PropTypes.object,
  dataCheckError: PropTypes.string,
  dataCheckErrorStyle: PropTypes.object,
  dataCheckValue: PropTypes.any,  // eslint-disable-line react/forbid-prop-types
  dataExtract: PropTypes.string,
  dataField: PropTypes.array,
  dataName: PropTypes.object,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  errorStyle: PropTypes.object,
  label: PropTypes.string,
  labelPosition: PropTypes.string,
  labelStyle: PropTypes.object,
  name: PropTypes.string,
  onClick: PropTypes.func,
  showError: PropTypes.bool,
  style: PropTypes.object,
  styleName: PropTypes.string,
  toggled: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const {
    data,
    dataCheckError: error,
    dataCheckErrorStyle: errorStyle,
    dataCheckValue,
    dataExtract,
    dataField,
    dataName
  } = props;
  let showError = false;
  dataField.forEach(fieldName => {
    const field = data[fieldName];
    // stop checking if anything error out
    if (field && !showError) {
      const dataType = dataName[fieldName];
      const selectedData = Object.values(getCategoryDataForType(state, dataType)).find(({id}) => id === field);
      if (selectedData) {
        const value = selectedData[dataExtract];
        showError = value === dataCheckValue;
      }
    }
  });
  return { error, errorStyle, showError };
};

export default connect(mapStateToProps, {})(Toggle);
